module.exports = __webpack_public_path__ + "media/images/iconPaginateLast__errorRed-333e719cef1670c82f4111480bc38a49.png";